(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/team-members/active-member.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/team-members/active-member.js');
'use strict';

const {
  InfoPairAmount,
  MemberPopover,
  MemberPopoverItem
} = svs.arena.pages.teams.components;
const {
  MemberSendEmail,
  MemberName
} = svs.arena.pages.teams.teamMembers;
const Button = svs.ui.ReactButton;
const {
  memberRoles
} = svs.arena.constants;
const {
  changeMemberActivity,
  setTeamBalance,
  changeMemberRole
} = svs.arena.store.teams.actions;
const {
  postDeactivateMemberAsync,
  putAdminMemberAsync
} = svs.arena.service.teamsService;
const {
  useRemoveMember
} = svs.arena.shared.hooks;
const {
  showDeactivateMemberSuccess,
  showTechnicalError,
  showConfirmDeactivateDialog,
  showAddedAdminSuccess,
  showRemovedAdminSucess
} = svs.arena.pages.teams.dialogs;
const ActiveMember = _ref => {
  let {
    member,
    teamId,
    isLeader,
    teamName
  } = _ref;
  const {
    customerId,
    firstName,
    lastName,
    memberBalance
  } = member;
  const dispatch = ReactRedux.useDispatch();
  const [isShowEmail, setIsShowEmail] = React.useState(false);
  const hasBalance = parseInt(member.memberBalance, 10) > 0;
  const isInactive = false;
  const {
    onRemoveMember
  } = useRemoveMember(teamId, teamName, customerId, firstName, lastName, hasBalance && memberBalance, isInactive);
  const setMemberInactive = async () => {
    const dialogResponse = await showConfirmDeactivateDialog(firstName, member.memberBalance);
    const track = {
      category: 'spela-tillsammans',
      action: 'action_members',
      opt_label: dialogResponse ? 'rest' : 'rest_cancel'
    };
    svs.components.analytics.trackEvent(track);
    if (!dialogResponse) {
      return;
    }
    const dispatchDeactiveActions = () => {
      dispatch(changeMemberActivity({
        teamId,
        customerId,
        active: false
      }));
      if ((member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.ADMIN) {
        dispatch(changeMemberRole({
          teamId,
          customerId,
          memberRole: memberRoles.NORMAL
        }));
      }
    };
    const responseDeactivate = await postDeactivateMemberAsync(customerId, teamId);
    if (responseDeactivate.error) {
      if (responseDeactivate.code === '22 108') {
        dispatchDeactiveActions();
        return;
      }
      showTechnicalError();
    } else {
      const {
        syndicateBalance,
        playableAmount
      } = responseDeactivate.data.syndicateAmounts;
      dispatchDeactiveActions();
      dispatch(setTeamBalance({
        teamId,
        syndicateBalance,
        playableAmount,
        customerId
      }));
      showDeactivateMemberSuccess(firstName, lastName);
    }
  };
  const showEmail = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'action_members',
      opt_label: 'show_email_field'
    };
    svs.components.analytics.trackEvent(track);
    setIsShowEmail(true);
  };
  const trackMemberAdmin = madeAdmin => ({
    category: 'spela-tillsammans',
    action: 'action_members',
    opt_label: madeAdmin ? 'add_member_place_bet' : 'remove_member_place_bet'
  });
  const addMemberAdmin = async () => {
    const response = await putAdminMemberAsync(customerId, teamId, true);
    if (response.error) {
      showTechnicalError();
    } else {
      svs.components.analytics.trackEvent(trackMemberAdmin(true));
      dispatch(changeMemberRole({
        teamId,
        customerId,
        memberRole: memberRoles.ADMIN
      }));
      showAddedAdminSuccess("".concat(member.firstName, " ").concat(member.lastName));
    }
  };
  const RemoveMemberAdmin = async () => {
    const response = await putAdminMemberAsync(customerId, teamId, false);
    if (response.error) {
      showTechnicalError();
    } else {
      svs.components.analytics.trackEvent(trackMemberAdmin(false));
      dispatch(changeMemberRole({
        teamId,
        customerId,
        memberRole: memberRoles.NORMAL
      }));
      showRemovedAdminSucess("".concat(member.firstName, " ").concat(member.lastName));
    }
  };
  return React.createElement("div", {
    className: "bg-tur-100 padding-1 u-border-radius-4 margin-v"
  }, React.createElement("div", {
    className: "u-flex f-400 line-height-1"
  }, React.createElement("div", {
    className: "u-flex-grow-1"
  }, React.createElement("div", {
    className: "data-hj-suppress"
  }, React.createElement(MemberName, {
    firstName: member.firstName,
    lastName: member.lastName
  })), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.TEAM_LEADER && React.createElement("div", null, "Lagledare"), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.ADMIN && React.createElement("div", null, "Spell\xE4ggare"), React.createElement(InfoPairAmount, {
    amount: member.memberBalance,
    isColor: !hasBalance,
    title: "Saldo i laget"
  })), !member.isCurrentMember && React.createElement("div", {
    className: "u-flex u-flex-align-items-center"
  }, isLeader && React.createElement(MemberPopover, null, React.createElement(MemberPopoverItem, {
    onClick: showEmail
  }, " Skicka e-post "), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.ADMIN && React.createElement(MemberPopoverItem, {
    onClick: RemoveMemberAdmin
  }, " Ta bort spell\xE4ggare "), (member === null || member === void 0 ? void 0 : member.memberRole) === memberRoles.NORMAL && React.createElement(MemberPopoverItem, {
    onClick: addMemberAdmin
  }, " G\xF6r till spell\xE4ggare "), React.createElement(MemberPopoverItem, {
    onClick: setMemberInactive
  }, " S\xE4tt vilande "), React.createElement(MemberPopoverItem, {
    onClick: onRemoveMember
  }, " Ta bort ")), !isLeader && React.createElement(Button, {
    onClick: () => setIsShowEmail(true),
    size: 100,
    transparent: true
  }, "Skicka e-post"))), isShowEmail && React.createElement(MemberSendEmail, {
    customerId: member.customerId,
    firstName: member.firstName,
    lastName: member.lastName,
    onHide: () => setIsShowEmail(false),
    teamId: teamId
  }));
};
svs.arena.pages.teams.teamMembers.ActiveMember = ActiveMember;

 })(window);